import { PHONE, locationSchema } from "../structured-data-core";

export function getVirginiaBeachStructuredData() {
  const url = "https://restorehair.com/locations/virginia/virginia-beach/";
  const description =
    "Find out about your hair transplant options in Virginia Beach with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Virginia Beach", "780 Lynnhaven Pkwy, Suite 400", "Virginia Beach", "VA", PHONE, url, description),
  ];
}
